/**
 * Stripe publishable keys and test-mode detection for the CRM UI.
 * Uses the same development check as Axios.js (NODE_ENV).
 */

import { loadStripe } from "@stripe/stripe-js";

const DEVELOPMENT_MODE = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

const STRIPE_PUBLISHABLE_KEY_LIVE =
  "pk_live_51OoZFZAsiu1ed7c1YKPHxo859668qe2if7w1douHxf067yDYzy2JN4CDAXm5JELuiSgFWFc3dwrLgJaQjPdYoRI300gsuh0TGx";

const STRIPE_PUBLISHABLE_KEY_TEST =
  "pk_test_51Sxq6BAVOLcrx4ypThoNDoBhKfqOU9rwYZps6R7APVtO53Ru2x5iB4YIacZCeELIvmCkG0bUZhXyWln4V0eNFC2400AYqfymwm";

export function isStripeTestMode() {
  return DEVELOPMENT_MODE;
}

export function getStripePublishableKey() {
  return DEVELOPMENT_MODE ? STRIPE_PUBLISHABLE_KEY_TEST : STRIPE_PUBLISHABLE_KEY_LIVE;
}

/** Shared Stripe promise – enables the dev testing assistant in dev mode */
export const stripePromise = loadStripe(getStripePublishableKey(), {
  ...(DEVELOPMENT_MODE && {
    developerTools: { assistant: { enabled: true } },
  }),
});
